<template>
  <div>
    <!-- RESULT - SEARCH -->
    <div v-if="user != ''">
      <!-- <v-card v-show="user != ''"> -->
      <v-card class="mb-3">
        <div class="d-flex px-3 pt-3">
          <v-avatar class="mb-2" color="grey darken-2" size="80">
            <v-icon dark size="80"> mdi-account-circle </v-icon>
          </v-avatar>
          <div class="flex-column ml-3 flex-grow-1">
            <!-- Name -->
            <div
              :class="
                $vuetify.breakpoint.mobile ? '' : 'd-flex flex-row-reverse'
              "
            >
              <div
                :class="
                  $vuetify.breakpoint.mobile
                    ? 'text-right'
                    : 'd-flex justify-end mb-0 align-top'
                "
              >
                <MenuDropdownStatusUser
                  v-if="!retrieveSelfSuspended == true"
                  :id_user="user.id"
                  :status_user="user.status"
                  v-on:suspendUser="suspendUser"
                  user_level="player"
                  ref="dropdownStatusUser"
                />
              </div>
              <div class="headline flex pa-1">
                {{ user.nome }}
                <v-tooltip top v-if="online == '1'">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon>
                      <v-icon color="primary">mdi-check-decagram</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("canPlaceBetsOnline") }}</span>
                </v-tooltip>
                <v-icon :color="colorStatus(user.status)" size="16">
                  mdi-circle
                </v-icon>

                <VerifyPlayerEmail
                  v-if="emailNotVerified"
                  :user_id="id_player || $route.query.id_user"
                  @getPlayer="getPlayer"
                />

                <div
                  :class="{
                    'd-flex align-center': !$vuetify.breakpoint.xsOnly
                  }"
                >
                  <div
                    class="d-flex flex-wrap"
                    :class="userTags.length > 0 ? 'my-2' : 'mt-1'"
                    style="overflow-y: hidden;"
                    :style="{
                      'max-height': $vuetify.breakpoint.xsOnly
                        ? '24px'
                        : '32px'
                    }"
                  >
                    <div
                      v-for="(tag, index) in userTags.slice(0, 3)"
                      :key="index"
                      class="rounded-pill px-3 mr-2"
                      :class="[$vuetify.breakpoint.xsOnly
                        ? 'caption'
                        : 'text-subtitle-1',
                      ]"
                      style="width: fit-content;"
                      :style="{
                        'background-color': tag.color + '80',
                        'color': 'white',
                        'border': '2px solid ' + tag.color,
                      }"
                    >
                      {{ tag.title }}
                    </div>
                  </div>

                  <div
                    class="d-flex align-center"
                    :class="$vuetify.breakpoint.xsOnly ? 'my-2' : 'my-3'"
                  >
                    <DialogAddOrRemove
                      :userId="id_player || $route.query.id_user"
                      :userTags="userTags"
                      :listTags="listTags"
                      @updateUserListTags="getListTagsFromUser"
                    />
                  </div>
                </div>

                <div v-if="suspensionButton" class="d-flex align-center">
                  <DialogSuspendedPlayer :suspensionData="suspensionData" />
                  <v-divider
                    :class="suspensionButton ? 'ml-2' : ''"
                  ></v-divider>
                </div>
                <div v-else>
                  <v-divider
                    :class="suspensionButton ? 'ml-2' : 'mt-2'"
                  ></v-divider>
                </div>
              </div>
            </div>
            <!-- Dados -->
            <v-row class="py-2 pl-1">
              <v-col cols="12" md="4" class="py-1">
                <div>ID: {{ user.id }}</div>
                <div>{{ $t("login") }}: {{ user.login }}</div>
              </v-col>
              <v-col cols="12" md="4" class="py-1">
                <div>{{ $t("balance") }}: {{ user.saldo_jogador }}</div>
                <div>{{ $t("bonus") }}: {{ user.saldo_bonus }}</div>
                <div>{{ $t("factor") }}: {{ user.fator }}</div>
              </v-col>
              <v-col cols="12" md="4" class="py-1">
                <div>{{ $t("cellPhone") }}: {{ user.celular }}</div>
                <div>Email: {{ user.email }}</div>
              </v-col>
            </v-row>
          </div>
        </div>
        <v-card-text class="pt-0">
          <v-btn-toggle mandatory class="d-flex">
            <!-- PERFIL -->
            <v-btn
              class="caption"
              style="flex: 1"
              @click="
                [
                  (enableTab = 0),
                  $router
                    .push({
                      name:
                        'AdministratorAccountabilityOnlinePlayersOnlineSearch',
                    })
                    .catch((err) => {}),
                ]
              "
            >
              <v-icon>mdi-account-circle-outline</v-icon>
              <div class="ml-2" v-show="!$vuetify.breakpoint.xsOnly">
                {{ $t("profile") }}
              </div>
            </v-btn>

            <!-- RELATÓRIO ANALÍTICO -->
            <v-btn
              class="caption"
              style="flex: 1"
              @click="
                [
                  (enableTab = 5),
                  $router
                    .push({
                      name: 'AdministratorAnalyticalReportPlayer',
                    })
                    .catch((err) => {}),
                ]
              "
            >
              <v-icon>mdi-chart-line</v-icon>
              <div class="ml-2" v-show="!$vuetify.breakpoint.xsOnly">
                {{
                  $vuetify.breakpoint.width >= 1450
                    ? $t("analyticReport")
                    : $t("report")
                }}
              </div>
            </v-btn>

            <!-- APOSTAS -->
            <v-btn
              class="caption"
              style="flex: 1"
              @click="
                [
                  (enableTab = 1),
                  $router
                    .push({
                      name: 'AdministratorBetListPlayerOnline',
                    })
                    .catch((err) => {}),
                ]
              "
            >
              <v-icon>mdi-ticket-confirmation-outline</v-icon>
              <div class="ml-2" v-show="!$vuetify.breakpoint.xsOnly">
                {{ $t("bets") }}
              </div>
            </v-btn>

            <!-- DEPOSITAR -->
            <v-btn
              v-if="!['betclub7', 'viapix'].includes(domain)"
              class="caption"
              style="flex: 1"
              @click="
                [
                  (enableTab = 2),
                  $router
                    .push({
                      name: 'AdministratorTransferForOnlinePlayer',
                    })
                    .catch((err) => {}),
                ]
              "
            >
              <v-icon>mdi-credit-card-outline</v-icon>
              <div class="ml-2" v-show="!$vuetify.breakpoint.xsOnly">
                {{ $t("transfer") }}
                <!-- {{ depositForPlayer ? $t("depositForPlayer") : $t("credit") }} -->
              </div>
            </v-btn>

            <!-- LANÇAMENTOS -->
            <v-btn
              class="caption"
              style="flex: 1"
              @click="
                [
                  (enableTab = 3),
                  $router
                    .push({
                      name: 'AdministratorOnlinePlayerReleases',
                    })
                    .catch((err) => {}),
                ]
              "
            >
              <v-icon>mdi-chart-box-outline</v-icon>
              <div class="ml-2" v-show="!$vuetify.breakpoint.xsOnly">
                {{ $t("releases") }}
              </div>
            </v-btn>

            <!-- CONFIGURAÇÕES -->
            <v-btn
              class="caption"
              style="flex: 1"
              @click="
                [
                  (enableTab = 4),
                  $router
                    .push({
                      name: 'AdministratorConfigOnline',
                      query: { id_agent: user.id_agente },
                    })
                    .catch((err) => {}),
                ]
              "
            >
              <v-icon>mdi-cog-outline</v-icon>
              <div class="ml-2" v-show="!$vuetify.breakpoint.xsOnly">
                {{ $t("settings") }}
              </div>
            </v-btn>
          </v-btn-toggle>
        </v-card-text>
      </v-card>

      <!-- ======================== -->
      <!-- TAB: PROFILE             -->
      <div v-show="enableTab == 0">
        <h2 class="mt-6 mb-2">{{ $t("profile") }}</h2>
        <v-card class="px-1">
          <v-list class="d-flex flex-row flex-wrap">
            <template v-for="(value, name) in user">
              <div
                :key="name"
                :style="
                  $vuetify.breakpoint.xsOnly ? 'width: 100%' : 'width: 50%'
                "
                class="d-flex flex-grow-1"
              >
                <v-list-item
                  dense
                  style="border-radius: 8px"
                  class="ma-1 grey"
                  :class="$vuetify.theme.dark ? 'darken-3' : 'lighten-3'"
                >
                  <v-list-item-content>
                    <v-list-item-title class="caption">{{
                      name | formatName
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action-text>
                    {{ value }}
                  </v-list-item-action-text>
                </v-list-item>
              </div>
            </template>
          </v-list>
        </v-card>
      </div>

      <!-- ======================== -->
      <!-- TAB: RELATÓRIO ANALÍTICO -->
      <div v-if="enableTab == 5">
        <h2 class="mt-6 mb-2">{{ $t("analyticReport") }}</h2>

        <AnalyticalReportByPlayer :userId="id_player" />
      </div>

      <!-- ======================== -->
      <!-- TAB: APOSTAS             -->
      <div v-show="enableTab == 1">
        <h2 class="mt-6 mb-2">{{ $t("bets") }}</h2>
        <v-card>
          <ListOnline />
        </v-card>
      </div>

      <!-- ======================== -->
      <!-- TAB: CREDITS             -->
      <!-- <div v-if="enableTab == 2 && !depositForPlayer">
        <h2 class="mt-6 mb-2">{{ $t("credit") }}</h2>
        <v-card>
          <historic />
        </v-card>
      </div> -->

      <!-- ======================== -->
      <!-- TAB: DEPOSIT FOR PLAYER  -->
      <div v-if="enableTab == 2">
        <h2 class="mt-6 mb-2">{{ $t("transfer") }}</h2>
        <v-card>
          <TransferForPlayerOnline
            :userLogin="userLogin"
            :userName="userName"
            :userId="userId"
          />
        </v-card>
      </div>

      <!-- ======================== -->
      <!-- TAB: RELEASES  -->
      <div v-if="enableTab == 3">
        <h2 class="mt-6 mb-2">{{ $t("releases") }}</h2>
        <v-card>
          <ReleasesOnline />
        </v-card>
      </div>

      <!-- ======================== -->
      <!-- TAB: CONFIG              -->
      <div v-show="enableTab == 4">
        <h2 class="mt-6 mb-2">{{ $t("settings") }}</h2>
        <v-card class="pa-4">
          <v-form>
            <div v-if="formEditPix">
              <div class="d-flex overline justify-start align-center pt-3 pb-2">
                <v-icon class="grey--text" small>mdi-cash-100</v-icon>
                <div class="pl-2 grey--text" style="font-size: 14px">
                  {{ $t("pixKey") }}
                </div>
                <v-divider class="ml-4"></v-divider>
              </div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="select_tipos_chave"
                    solo-inverted
                    dense
                    return-object
                    :items="tipos_chave"
                    item-text="label"
                    item-value="value"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    solo-inverted
                    dense
                    v-model="chave_pix"
                    :label="label_pix"
                    v-mask="mask_pix"
                    clearable
                    :error="errorActive"
                    :error-messages="errorMessage"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>

            <div v-if="showAffiliation">
              <div class="d-flex overline justify-start align-center pt-3 pb-2">
                <v-icon class="grey--text" small>mdi-cash-100</v-icon>
                <div class="pl-2 grey--text" style="font-size: 14px">
                  {{ $t("playerAffiliation") }}
                </div>
                <v-divider class="ml-4"></v-divider>
              </div>
              <p class="caption">{{ $t("whichAgentIdCanRequestAffiliate") }}</p>
              <div class="py-2">
                <div class="caption pb-2 pt-2">{{ $t("searchAgent") }}:</div>
                <v-autocomplete
                  v-model="search_select_agent"
                  :items="search_agent_items"
                  :loading="search_agent_isLoading"
                  :search-input.sync="search_sync"
                  @change="setAgentId"
                  prepend-icon="mdi-account"
                  :label="$t('searchAgent')"
                  item-text="ui"
                  item-value="id"
                  dense
                  filled
                  hide-details
                  solo-inverted
                  return-object
                  clearable
                ></v-autocomplete>
              </div>
              <div class="caption pb-2 pt-2">{{ $t("defineTheAgent") }}:</div>
              <v-text-field
                dense
                hide-details=""
                v-model="agentId"
                solo-inverted
                type="number"
              >
              </v-text-field>
            </div>

            <div class="d-flex overline justify-start align-center pt-6">
              <v-icon class="grey--text" small>mdi-account-alert</v-icon>
              <div class="pl-2 grey--text" style="font-size: 14px">
                {{ $t("userLimits") }}
              </div>
              <v-divider class="ml-4"></v-divider>
            </div>
            <div class="caption pt-3 pb-2">
              {{ $t("realiabilityFactor") }}:
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small icon v-bind="attrs" v-on="on">
                    <v-icon small color="info">
                      mdi-information-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("realiabilityFactorTip") }}</span>
              </v-tooltip>
            </div>
            <v-text-field dense v-model="fator" solo-inverted type="number">
            </v-text-field>

            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="info" @click="saveConfig()">{{
                $t("toSave")
              }}</v-btn>
            </v-card-actions>

            <div v-if="hasDocumentVerification">
              <div class="d-flex overline justify-start align-center pt-6">
                <v-icon class="grey--text" small>mdi-account-alert</v-icon>
                <div class="pl-2 grey--text" style="font-size: 14px">
                  {{ $t("verification") }}
                </div>
                <v-divider class="ml-4"></v-divider>
              </div>
              <div class="caption pt-3 pb-2">
                {{ $t("verificationOfDocument") }}:
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn x-small icon v-bind="attrs" v-on="on">
                      <v-icon small color="info">
                        mdi-information-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("documentVerificationTooltip") }}</span>
                </v-tooltip>
              </div>
              <div class="pb-6 d-flex flex-column">
                <v-select
                  v-model="documentVerification"
                  :items="documentVerificationItems"
                  return-object
                  dense
                  solo-inverted
                  disabled
                  hide-details
                  class="pr-2 pb-2 d-none"
                ></v-select>

                <v-chip
                  :color="
                    documentVerificationChips[documentVerification.value].color
                  "
                  outlined
                  style="
                    max-width: fit-content;
                    border-radius: 10px;
                    height: 37px;
                    padding: 11px 15px;
                  "
                >
                  {{
                    documentVerificationChips[documentVerification.value].text
                  }}
                </v-chip>

                <v-divider class="mt-6" />
                <v-card-actions>
                  <v-spacer />
                  <DocumentVerificationDialog
                    :userId="userId"
                    :disabled="documentVerification.value != '2'"
                    @updateDocumentVerification="updateDocumentVerification"
                  />
                </v-card-actions>
              </div>
            </div>
          </v-form>
        </v-card>
      </div>
    </div>
    <v-dialog v-model="dialog" width="600" persistent>
      <v-card>
        <v-card-title class="text-h5">
          {{ currStatus == 3 ? $t("disableReason") : $t("suspensionReason") }}
        </v-card-title>
        <v-card-text v-if="currStatus == 3">
          {{ $t("warningDisable") }}
        </v-card-text>
        <div class="mx-auto px-6">
          <v-select
            v-model="selectedReason"
            :placeholder="
              currStatus == 3
                ? $t('selectAReasonToDisable')
                : $t('selectAReasonToSuspend')
            "
            solo-inverted
            dense
            return-object
            :items="selectReasonItems"
            item-text="label"
            item-value="value"
            @change="reasonChanged"
          ></v-select>
          <v-textarea
            maxlength="300"
            class="px-2"
            auto-grow
            outlined
            rows="2"
            row-height="15"
            :placeholder="
              currStatus == 3
                ? $t('textAreaPlaceholderDisable')
                : $t('textAreaPlaceholderSuspension')
            "
            v-model="reason"
            v-if="showReasonTextarea"
          />
        </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">
            {{ $t("toCancel") }}
          </v-btn>
          <v-btn color="primary" text @click="confirmSuspendUser">
            {{ $t("toConfirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import MenuDropdownStatusUser from "@/components/administrator/menu/dropdownStatusUser.vue";
import ListOnline from "./listPlayersOnline.vue";
import TransferForPlayerOnline from "./transferForPlayerOnline.vue";
import ReleasesOnline from "./releasesOnline.vue";
import DialogSuspendedPlayer from "@/components/common/dialog/dialogSuspendedPlayer";
import DocumentVerificationDialog from "@/components/common/documentVerification";
import AnalyticalReportByPlayer from "./AnalyticalReportByPlayer.vue";
import VerifyPlayerEmail from "@/views/backoffice/shared/VerifyPlayerEmail";
import DialogAddOrRemove from "@/views/backoffice/shared/users/players/tagsConfig/DialogAddOrRemove";

export default {
  components: {
    ListOnline,
    MenuDropdownStatusUser,
    TransferForPlayerOnline,
    ReleasesOnline,
    DialogSuspendedPlayer,
    DocumentVerificationDialog,
    AnalyticalReportByPlayer,
    VerifyPlayerEmail,
    DialogAddOrRemove,
  },
  name: "amdinistrator-accountabilityOnline-playerOnlineSearch",
  data: (_this) => ({
    suspensionData: {},
    suspensionButton: false,
    limitSuspension: "",
    currStatus: null,
    online: "",
    user: "",
    userDataColumn1: [],
    userDataColumn2: [],
    enableTab: 0,
    /// TabConfig:
    agentId: "",
    fator: "",
    // Search Agents (TabConfig):
    search_select_agent: null,
    search_agent_items: [],
    search_agent_isLoading: false,
    search_sync: null,
    term: "",

    // Edição de Chave Pix
    tipos_chave: [
      {
        label: "Selecione",
        value: "",
      },
      {
        label: "CPF",
        value: "CPF",
      },
      {
        label: "E-mail",
        value: "EMAIL",
      },
      {
        label: "Telefone",
        value: "PHONE",
      },
      {
        label: "Chave aleatória",
        value: "EVP",
      },
    ],
    chave_pix: "",
    select_tipos_chave: {
      label: "Selecione",
      value: "",
    },
    label_pix: "000.000.000-00",
    mask_pix: "###.###.###-##",
    errorActive: false,
    errorMessage: "",
    formEditPix: false,
    userLogin: "",
    userName: "",
    userId: "",
    depositForPlayer: false,
    ultimo_login: "",
    dialog: false,
    reason: "",
    showReasonTextarea: false,
    selectedReason: null,
    selectReasonItems: [],
    sigla: "",
    userTags: [],
    listTags: [],

    documentVerification: {},
    documentVerificationItems: [],
    documentVerificationChips: {
      1: {
        text: _this.$t("pending"),
        color: "#F64B20",
      },
      2: {
        text: _this.$t("documentInAnalysis"),
        color: "#FFEB3B",
      },
      3: {
        text: _this.$t("concluded"),
        color: "#4CAF50",
      },
      4: {
        text: _this.$t("verificationDenied"),
        color: "#FF2929",
      },
    },

    domain: localStorage.getItem("operator"),
    initialAgentId: "",
    confirmed_email: null,
  }),
  mounted() {
    this.selectReasonItems = [
      {
        label: this.$t("bugAbuse"),
        value: this.$t("bugAbuse"),
      },
      {
        label: this.$t("outdatedInformation"),
        value: this.$t("outdatedInformation"),
      },
      {
        label: this.$t("termsAndConditionsViolation"),
        value: this.$t("termsAndConditionsViolation"),
      },
      {
        label: this.$t("financialProtection"),
        value: this.$t("financialProtection"),
      },
      {
        label: this.$t("doubleAccount"),
        value: this.$t("doubleAccount"),
      },
      {
        label: this.$t("suspiciousBehavior"),
        value: this.$t("suspiciousBehavior"),
      },
      {
        label: this.$t("other"),
        value: "Outro",
      },
    ];

    // Está na aba online ou já está na rota de depósito
    // this.depositForPlayer =
    //   this.$route.name ===
    //     "AdministratorAccountabilityOnlinePlayersOnlineSearch" ||
    //   this.$route.name === "AdministratorTransferForOnlinePlayer";

    var credit = localStorage.getItem("operator-credit");
    if (credit == 2) {
      this.formEditPix = true;
    } else {
      this.formEditPix = false;
    }

    this.documentVerificationItems = [
      {
        text: this.$t("pending"),
        value: 1,
      },
      {
        text: this.$t("documentInAnalysis"),
        value: 2,
      },
      {
        text: this.$t("concluded"),
        value: 3,
      },
      {
        text: this.$t("verificationDenied"),
        value: 4,
      },
    ];

    // this logic is now on AutocompletePlayers
    // if (this.$route.query.id_user) {
    //   this.getPlayer();
    // }
  },

  computed: {
    emailNotVerified() {
      return this.confirmed_email && this.confirmed_email == "0";
    },
    showAffiliation() {
      const agentId = this.initialAgentId;

      if (!agentId) {
        return false;
      }

      const allowAffiliationUpdate = [
        "2583805",
        "3963907",
        "4710644",
        "4710627",
        "4639953",
        "3963924",
        "3590435",
      ];

      return allowAffiliationUpdate.includes(agentId);
    },
    hasDocumentVerification() {
      return (
        this.$store.state.operator &&
        this.$store.state.operator.document_verification == "1"
      );
    },
    getOperatorPaymentMethods() {
      return this.$store.state.operator.payment_methods ?? [];
    },
    refresh() {
      return this.$store.getters.getRefresh;
    },
    progress() {
      return this.$store.state.feedbackProgress;
    },
    id_player() {
      return this.$store.state.filters.autocompletePlayers.id;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
  },
  watch: {
    refresh(val) {
      val && this.getPlayer();
      this.$store.commit("setRefresh", false);
    },
    search_sync(val) {
      // Caso o usuário selecionar um usuário da lista
      // não permitir realizar o get novamente.
      // O regex abaixo identifica os caracteres "(" e ")"
      // Contido na string e encerra dando return.
      if (/\(|\)/.test(val)) return;
      if (!val || val.length <= 0) {
        this.search_agent_items = [];
        this.sigla = "";
        this.term = "";
        return;
      }
      if (this.search_agent_isLoading) return;
      // Request

      if (val.length != 3 || val == this.sigla) {
        return;
      }

      this.sigla = val;

      if (val.length >= 3 && val != this.term) {
        this.term = val;
        this.getAgentsSearch();
      }
    },
    saveFilters(val) {
      val && this.getPlayer();
    },

    select_tipos_chave(val) {
      switch (val.value) {
        case "CPF":
          this.label_pix = "000.000.000-00";
          this.mask_pix = "###.###.###-##";
          break;
        case "EMAIL":
          this.label_pix = "exemplo@email.com";
          this.mask_pix = null;
          break;
        case "PHONE":
          this.label_pix = "(00) 90000-0000";
          this.mask_pix = "(##) #####-####";
          break;
        case "EVP":
          this.label_pix = "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxx";
          this.mask_pix = null;
          break;
        default:
          return;
      }
    },
    chave_pix() {
      this.errorMessage = "";
      this.errorActive = false;
    },
  },
  methods: {
    updateDocumentVerification(status) {
      this.documentVerification = this.documentVerificationItems.find(
        (item) => item.value == status
      );
    },
    reasonChanged() {
      if (this.selectedReason.value == "Outro") {
        this.showReasonTextarea = true;
      } else {
        this.showReasonTextarea = false;
      }
    },
    confirmSuspendUser() {
      if (this.selectedReason == null) {
        this.$store.commit("setFeedbackSnack", {
          msg:
            this.currStatus == 3
              ? this.$t("selectAReasonToDisable")
              : this.$t("selectAReasonToSuspend"),
          color: "error",
        });
        return;
      }
      if (this.selectedReason.value == "Outro") {
        if (this.reason == "") {
          this.$store.commit("setFeedbackSnack", {
            msg:
              this.currStatus == 3
                ? this.$t("selectAReasonToDisable")
                : this.$t("selectAReasonToSuspend"),
            color: "error",
          });
          return;
        }
        this.$refs.dropdownStatusUser.changeStatus(this.reason);
        this.dialog = false;
        return;
      } else {
        this.$refs.dropdownStatusUser.changeStatus(this.selectedReason.value);
        this.dialog = false;
      }
    },
    suspendUser(status) {
      if (status == 0 || status == 3) {
        this.currStatus = status;
        this.dialog = true;
      }
    },
    /// Set Save in store vuew;
    save() {
      this.$store.commit("setSave", true);
    },
    getListTagsFromUser() {
      let userListTags = [];
      let listTags = [];

      this.$axios
        .post(`${this.$prefix()}/players/listTagsFromUser`, this.$formdata({
          user_id: this.id_player || this.$route.query.id_user,
        }))
        .then((res) => {
          res.data.dados.forEach((tag) => {
            let tagFormatted = {
              ...tag,
              id: tag.tag_id,
            };

            if (tag.id_usuario == 0) {
              listTags.push(tagFormatted);
            } else {
              userListTags.push(tagFormatted);
            }
          });

          this.userTags = userListTags;
          this.listTags = listTags;
        });
    },
    /// Get Player
    async getPlayer() {
      if (!this.id_player && !this.$route.query.id_user) {
        this.playerIsRequired();
        return;
      }

      const body = {
        id_user: this.$route.query.id_user || this.id_player,
      };

      const response = await this.$request.post(
        "administrator/players/getPlayer",
        body
      );
      if (response.length == 0) return;

      if (response.suspension_data) {
        this.suspensionButton = true;
        this.suspensionData = response.suspension_data;
        if (this.suspensionData.suspension_author == "self") {
          response.dados.status = 0;
          this.suspensionData.limite_suspensao = new Date(
            this.suspensionData.limite_suspensao.replace(" ", "T")
          ).toLocaleDateString();
          this.suspensionData.suspension_author = this.$t("selfSuspended");
        }
        this.suspensionData.suspension_start_date = new Date(
          this.suspensionData.suspension_start_date.replace(" ", "T")
        ).toLocaleDateString();
      } else {
        this.suspensionButton = false;
      }

      this.documentVerification = this.documentVerificationItems.find(
        (item) => item.value == response.dados.cadastro_validado
      );
      // Amazena o dado selfSuspended para usar na condicional do menuDropdown
      this.retrieveSelfSuspended = response.dados.selfSuspended;

      delete response.dados.suspenso;
      delete response.dados.limite_suspensao;
      delete response.dados.selfSuspended;

      this.user = response.dados;
      this.fator = this.user.fator;
      this.agentId = this.user.id_agente;
      this.initialAgentId = this.user.id_agente;
      this.online = this.user.online;
      this.userLogin = this.user.login;
      this.userName = this.user.nome;
      this.userId = this.id_player;
      const birthDate = new Date(this.user.data_nascimento);
      birthDate.setDate(birthDate.getDate() + 1);
      this.user.data_nascimento = birthDate.toLocaleString().slice(0, 10);
      this.confirmed_email = response.dados.confirmed_email;

      // tratando url com query user_id
      if (
        this.$route.query.id_user &&
        this.$route.query.id_user != this.user.id
      ) {
        this.$router.replace({ query: { id_user: this.user.id } });
      }

      this.user.ultimo_login = this.user.ultimo_login
        ? new Date(this.user.ultimo_login).toLocaleString()
        : "";

      // Tratamento para o frontEnd caso não haja informações de email
      if (response.dados.email == null || "") {
        this.user.email = "Não cadastrado";
      }

      if (response.dados.verificacao_bancaria) {
        const bankVerificationStatus = {
          0: this.$t("verificationNotStarted"),
          1: this.$t("verificationSuccess"),
          2: this.$t("verificationInProgress"),
          3: this.$t("verificationDenied"),
        };

        response.dados.verificacao_bancaria =
          bankVerificationStatus[response.dados.verificacao_bancaria];
      }

      await this.getListTagsFromUser();
    },
    /// Color for Status User Player
    colorStatus(status) {
      if (status == 0) return "red";
      if (status == 1) return "green";
      if (status == 2) return "orange";
    },

    validPix() {
      var tipo_chave = this.select_tipos_chave.value;
      // Se vazio!
      if (
        this.chave_pix == "" ||
        this.chave_pix == undefined ||
        this.chave_pix == null
      ) {
        return true;
      }
      switch (tipo_chave) {
        case "CPF":
          return (
            this.chave_pix.length === 14 ||
            this.errorPix("Digite um CPF válido!")
          );
        case "EMAIL":
          return (
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              this.chave_pix
            ) || this.errorPix("digite um e-mail válido")
          );
        case "PHONE":
          return (
            this.chave_pix.length === 15 ||
            this.errorPix("Digite um telefone válido!")
          );
        case "EVP":
          return (
            this.chave_pix.length === 36 ||
            this.errorPix("Digite um chave aleatória válida!")
          );
        default:
          return true;
      }
    },
    // Error Form Pix - Validação
    errorPix(msg) {
      this.errorActive = true;
      this.errorMessage = msg;
      return false;
    },
    /// TabConfig - Action Save
    async saveConfig() {
      var chave_pix = "";

      if (!this.validPix()) return;

      if (this.select_tipos_chave.value === "PHONE") {
        chave_pix = this.chave_pix.replace(/[^0-9]+/g, "");
        chave_pix = `+55${chave_pix}`;
      }
      if (this.select_tipos_chave.value === "CPF") {
        chave_pix = this.chave_pix.replace(/[^0-9]+/g, "");
      }

      const body = {
        id_user: this.id_player,
        fator: this.fator,
        id_agente: this.agentId,
        tipo_chave:
          this.chave_pix == "" ||
          this.chave_pix == null ||
          this.chave_pix == undefined
            ? ""
            : this.select_tipos_chave.value,
        chave: chave_pix || this.chave_pix,
      };

      const result = await this.$request.post(
        "administrator/players/editPlayer",
        body
      );

      if (result.length == 0) return;

      if (this.agentId) {
        this.initialAgentId = this.agentId;
      }

      this.$store.commit("setFeedbackSnack", {
        msg: result.messages,
        color: "success",
      });
    },
    // TabConfig - getAgentsSearch
    async getAgentsSearch() {
      this.search_agent_isLoading = true;
      try {
        const response = await this.$request.post(
          "administrator/agents/search",
          { term: this.term }
        );
        if (response.length == 0) {
          this.items = [];
          return;
        }
        this.search_agent_items = response.dados.map((item) => ({
          ui: `${item.nome} (${item.login} ${item.id})`,
          name: item.nome,
          login: item.login,
          id: item.id,
        }));
      } finally {
        this.search_agent_isLoading = false;
      }
    },
    // TabConfig - getAgentsSearch - action select
    setAgentId(select) {
      this.agentId = select.id;
    },
    // resendConfirm
    async resendConfirm(type) {
      const body = {
        id_user: this.user.id,
      };
      const response = await this.$request.post(
        `administrator/players/resend${type}`,
        body
      );
      if (response.length == 0) return;
      this.$store.commit("setFeedbackSnack", {
        msg: response.messages,
        color: "success",
      });
    },
    playerIsRequired() {
      this.$store.commit("setFeedbackSnack", {
        msg: this.$t("playerNameIsRequired"),
        color: "warning",
      });
      this.$store.commit("setSave", false);
      this.$store.commit("DisabledSave", false);
    },
  },
  filters: {
    formatName(val) {
      var name = val.replace("_", " ");
      return name.charAt(0).toUpperCase() + name.slice(1);
    },
  },
};
</script>
